<script>
    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
</script>

<button type="button" class="btn btn-primary position-fixed bottom-0 right-0 mb-5 mr-5" on:click={scrollToTop} aria-label="Back to top">
    <span class="sr-only">Back to top</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
        <path d="M7.646 4.146a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1-.708.708L8 5.707l-3.146 3.147a.5.5 0 0 1-.708-.708l3.5-3.5a.5.5 0 0 1 .708 0z"/>
        <path d="M8 16a.5.5 0 0 1-.5-.5V5.707L4.354 8.854a.5.5 0 0 1-.708-.708l3.5-3.5a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1-.708.708L8.5 5.707V15.5a.5.5 0 0 1-.5.5z"/>
    </svg>
</button>